import Head from "next/head";
import { getBrands } from "@components/config/helpers";
import dynamic from "next/dynamic";

const BarHirePackage = dynamic(() => import("Features/ECOMM/BarHirePackages/components/BarHirePackages"));

const BarHirePackages = () => {

    return (
        <>
            <Head>
                <title>{`Bar Hire Packages | ${process.env.brand.brand_name}`}</title>
                
                <meta
                    name="description"
                    content="Welcome to our Bar Package Selector, where discovering the ideal solution for your requirements is as simple as 1-2-3."
                />
            </Head>
            <BarHirePackage />
            
        </>
    );
};

export async function getServerSideProps({ query, res }) {
    
    res.setHeader(
        'Cache-Control',
        'public, s-maxage=43200, stale-while-revalidate=59'
      );

    if(!getBrands(['MBH'])) {
        return {notFound: true}
    }
    
    return {
        props: {
            data: {
                breadcrumb: {
                    'last': 'Bar Hire Packages',
                    'links': []
                },
                template_page_settings: {
                    sidenav: 'yes'
                }
            }
          }
        };
    
}

export default BarHirePackages;
